import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Checkbox from '@material-ui/core/Checkbox'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'

import ItemIcon from '@material-ui/icons/BeachAccess'
import ImageIcon from '@material-ui/icons/Image'

import { IconButton } from '@material-ui/core'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PaperBlock from '../../../ui/PaperBlock'

import ItemInfoDialog from '../../../inventory/Info/ItemInfoDialog'

import api from '../../../api'

/**
 * items
 * selected
 * completed
 * 
 * show_shopping_carts - показывать или нет кнопку корзинку около кнопки
 * shopping_list - список товаров который нужно закупить
 * 
 * onClickItem(item)
 * onDoubleClickItem(item)
 * onChangeItemIssuedClick(item)
 * onChangeItemReceivedClick(item)
 * onCartClick(item)
 */

class ListItems extends Component {

	constructor(props) {
		super(props)
		this.state = {
			dialog: undefined
		}
	}

	render() {
		
		let shopping_list = this.props.shopping_list || []

		return <PaperBlock>
			{this.state.dialog}
			<List>
				{this.props.items.map((item, n) => {

					let cart_color = shopping_list.find(itm => item.id === itm.id) ? "red" : "gray"

					return <ListItem
						key = {n}
						button
						disabled = {this.props.completed == 1}
						selected = {this.props.selected ? this.props.selected.id === item.id : false}
						onClick = {e => {
							e.stopPropagation()
							if (typeof this.props.onClickItem === "function") {
								this.props.onClickItem(item)
							}
						}}
						onDoubleClick = {e => {
							e.stopPropagation()
							if (typeof this.props.onDoubleClickItem === "function") {
								this.props.onDoubleClickItem(item)
							}
						}}
					>
						{/* Иконка с зонтиком */}

						<ListItemIcon>
							<ItemIcon />
						</ListItemIcon>

						{/* Название предмета, кол-во */}

						<ListItemText
							primary = {item.name}
							secondary = {`Кол-во: ${item.amount}`}
						/>

						{/* Кнопочки и галочки справа */}

						<div 
							style = {{
								flex: "0 0 auto",
							}}
						>
							
							<Tooltip title = "Выдано">
								<Checkbox
									disabled = {this.props.completed != 0 || (item.received == 1)}
									checked = {item.issued == 1}
									onClick = {e => {
										e.stopPropagation()
										if (typeof this.props.onChangeItemIssuedClick === "function") {
											this.props.onChangeItemIssuedClick(item)
										}
									}}
								/>
							</Tooltip>

							<Tooltip title = "Получено">
								<Checkbox
									disabled = {(this.props.completed != 0) || (item.issued != 1)}
									checked = {item.received == 1}
									onClick = {e => {
										e.stopPropagation()
										if (typeof this.props.onChangeItemReceivedClick === "function") {
											this.props.onChangeItemReceivedClick(item)
										}
									}}
								/>
							</Tooltip>
							
							{
								this.props.show_shopping_carts ? <Tooltip title="Выделить для закупки">
									<IconButton
										onClick={e => {
											e.stopPropagation()
											if (typeof this.props.onCartClick === "function") {
												this.props.onCartClick(item)
											}
										}}
									>
										<ShoppingCartIcon style = {{color: cart_color}} />
									</IconButton>
								</Tooltip> : undefined
							}

							{/* Просмотр фото для предмета */}

							<IconButton
								onClick={async e=>{
									e.stopPropagation()
									// В легаси коде была путаница в списке предметов, по этому сделал уверенную
									// загрузку информации о предмете. Иначе была ошибка с новыми добавлениями.
									let response = await api.inventory.get(item.item_id)
									this.setState({
										dialog: <ItemInfoDialog 
											item={ response.item } 
											onCloseButtonClick={()=>{this.setState({dialog: undefined})}}
										/>
									})
								}}
							>
								<ImageIcon />
							</IconButton>

						</div>
						
					</ListItem>

				})}
			</List>
		</PaperBlock>
	}

}

export default ListItems
